/**
 * Reserved provider tags (#248; plan §4.5). Tags are free text on the provider; these few mean something to the
 * system, matched without regard to case or surrounding space (the server and picaluna-v3's sync read them the same way).
 */

/** Out of the pickers for new bookings; arrangements that already use the provider still show it. */
export const RETIRED_TAG = 'Do not use for new bookings';
/** picaluna-v3 doesn't publish the provider. */
export const HIDE_FROM_WEBSITE_TAG = 'Hide From Website';

const norm = (v: unknown) => (typeof v === 'string' ? v.trim().toLowerCase() : '');

/** Whether provider tags (the form's chips, `{ value }` objects or strings, as an array or keyed by id) include this one. */
export function hasTag(tags: unknown, tag: string): boolean {
  if (!tags || typeof tags !== 'object') return false;
  const list: any[] = Array.isArray(tags) ? tags : Object.values(tags as Record<string, any>);
  return list.some((t) => (typeof t === 'string' ? norm(t) : t?._meta?.deleted ? '' : norm(t?.value)) === norm(tag));
}
